import { render, staticRenderFns } from "./Plafon_kesehatan.vue?vue&type=template&id=63a4f229"
import script from "./Plafon_kesehatan.vue?vue&type=script&lang=js"
export * from "./Plafon_kesehatan.vue?vue&type=script&lang=js"
import style0 from "./Plafon_kesehatan.vue?vue&type=style&index=0&id=63a4f229&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports